import { render, staticRenderFns } from "./editdatapush.vue?vue&type=template&id=08d36fae&"
import script from "./editdatapush.vue?vue&type=script&lang=ts&"
export * from "./editdatapush.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editdatapush.vue"
export default component.exports